import { useQuery } from '@tanstack/react-query';
import { fetchPlans, type PricingPlan } from '../api/plans';

export function usePlans() {
  return useQuery<PricingPlan[], Error>({
    queryKey: ['pricing-plans'],
    queryFn: fetchPlans,
    staleTime: 1000 * 60 * 5,
  });
}

